import {
  getAllNonSwatchImages,
  getCartItemDisplayPhoto,
  getWYWBackPhoto,
  SelectedVariantMap,
} from './variantHelpers';
import { Variant } from 'services/generated/commerce-service/models/Variant';
import { Product } from 'services/generated/commerce-service/models/Product';
import { getFirstVariant } from './productHelpers';

export type WYWImages = {
  front: string[];
  back: string[];
};

export const BAND_KEY = 'wyw-band';
export const CLASP_KEY = 'wyw-clasp';
export const HOOK_KEY = 'wyw-hook';
export const FAST_LINK_KEY = 'wyw-fast-link';
export const WYW_CATEGORIES_ORDER = [
  BAND_KEY,
  CLASP_KEY,
  HOOK_KEY,
  FAST_LINK_KEY,
];

// Appending -large (or another size) to the image url fetches a compressed
// version of the image from commerce tools. For now, we only need to use this for WYW
export const getCustomImageSize = (imageUrl: string) => {
  const list = imageUrl.split('.png');
  return list[0] + '-large.png';
};

// Get the base, band, clasp, hook, and link photos in 1 array so they
// <LayeredImage /> component can stack the photos
export const createWYWImagesObject = (
  wywVariant: Variant,
  selectedWywOptions: SelectedVariantMap,
): WYWImages => {
  let wywFrontImages: string[] = [];
  let wywBackImages: string[] = [];

  const baseFrontImage = getCartItemDisplayPhoto(wywVariant);
  const baseBackImage = getWYWBackPhoto(wywVariant);

  if (baseFrontImage) wywFrontImages.push(baseFrontImage);
  if (baseBackImage) wywBackImages.push(baseBackImage);

  Object.keys(selectedWywOptions).forEach((key) => {
    const frontImage = getCartItemDisplayPhoto(selectedWywOptions[key]);
    const backImage = getWYWBackPhoto(selectedWywOptions[key]);

    if (frontImage) wywFrontImages.push(getCustomImageSize(frontImage));
    if (backImage) wywBackImages.push(getCustomImageSize(backImage));
  });

  return { front: wywFrontImages, back: wywBackImages };
};

export const getAllWYWImages = (products: Product[]): string[] => {
  return products.reduce((stringArray: string[], product) => {
    const images = getAllNonSwatchImages(getFirstVariant(product)).map((img) =>
      getCustomImageSize(img),
    );
    stringArray.push(...images);
    return stringArray;
  }, []);
};
